
import { cloneDeep } from 'lodash';
import { ref, watch /*, reactive */, computed } from 'vue';

import { getCard }			from './CardsGetter';
import { loadoutStore } from '../store/LoadoutStore';

/* DATA */
const openManager = ref(false);
const _cardHeld = ref({});

const loadoutIDs = JSON.parse(localStorage.getItem('loadout-list') ?? '[]');
const loadoutList = ref(loadoutIDs.map(id => {
	const loadout = JSON.parse(localStorage.getItem(`loadout-${id}`));
	loadout.cards = loadout.cards.map(c => {
		if (c === null)
			return { empty: true };
		return { r5: c.r5, model: getCard(c.model?.id || c.id) };
	});
	return loadout;
}));

if (loadoutList.value.length)
	loadoutStore.set(loadoutList.value[0]);

/* COMPUTED */

const holdingCard = computed(() => !!Object.keys(_cardHeld.value).length);

const cardHeld = computed({
	get() {
		return holdingCard.value ? _cardHeld.value : null;
	},
	set(value) {
		if (value === null) {
			_cardHeld.value = {};
			if (openManager.value)
				openManager.value = false;
		} else {
			_cardHeld.value = value;
			openManager.value = true;
		}
	}
});

/* WATCH */
watch(() => openManager.value, (value) => {
	if (value === false && holdingCard.value)
		cardHeld.value = null;
});

/* METHODS */

function saveLoadout() {
	const currentLoadout = loadoutStore.getState();
	const isNew = !('_model' in currentLoadout);

	loadoutStore.save();
	if (isNew) {
		// both id and _model are created during store.save()
		loadoutIDs.push(currentLoadout.id);
		loadoutList.value.push(currentLoadout._model);
		localStorage.setItem('loadout-list', JSON.stringify(loadoutIDs));
	}
	const clone = cloneDeep(currentLoadout);
	clone._model.cards = clone._model.cards.map(c => c.empty ? null : { r5: c.r5, id: c.model.id });
	localStorage.setItem(`loadout-${clone.id}`, JSON.stringify(clone._model));
}

function deleteLoadout() {
	const currentLoadout = loadoutStore.getState();
	localStorage.removeItem(`loadout-${currentLoadout.id}`);
	{
		const i = loadoutList.value.indexOf(currentLoadout._model);
		if (i !== -1)
			loadoutList.value.splice(i, 1);
	}
	{
		const i = loadoutIDs.indexOf(currentLoadout.id);
		if (i !== -1) {
			loadoutIDs.splice(i, 1);
			localStorage.setItem('loadout-list', JSON.stringify(loadoutIDs));
		}
	}
	loadoutStore.clear();
}

export {
	openManager,
	cardHeld,
	loadoutList,
	saveLoadout,
	deleteLoadout,
	loadoutStore
};
